module.exports = __webpack_public_path__ + "media/images/holly-c8462fbbfd1558505e6412aa5adf4cb5.png";